import {
    getExport
} from "./export"
/*
export async function getExportHostConnection(type, params){
    return getExport(`/export/holderreport`, type, params);
}*/

export async function getExportBirthdayList(type, params){
    return getExport(`/export/holderbirthdayreport`, type, params)
}
